import { Customer } from '@mindfulchefuk/query'

export const emptyCustomerData: Customer = {
  address: {
    id: '',
    countryCode: '',
    street1: '',
    street2: '',
    street3: '',
    deliveryInstructions: '',
    locality: '',
    recipientPhone: '',
    postcode: '',
  },
  createdAt: '',
  contactPreferences: {
    id: '',
    emailMarketingOptIn: false,
    postMarketingOptIn: false,
    smsMarketingOptIn: false,
    phoneMarketingOptIn: false,
  },
  email: '',
  firstName: '',
  lastName: '',
  customerId: '',
  personalisationSurveyState: 'not_started',
}
